import { SubjectDesign } from '../shared/SubjectContent.types';

// Figma 최종 분리파일 및 2026-10-23 검수 반영. 좌표는 GNB 125px을 제외한 본문 기준.
export const finalDesign: SubjectDesign = {
    height: 11987,
    backgrounds: [
        {
            top: 10759,
            height: 1225,
            file: 'backdrop-10887.png',
        },
        {
            top: 9192,
            height: 1567,
            color: '#f3f3f3',
        },
        {
            top: 6782,
            height: 2410,
            file: 'backdrop-6910.png',
        },
        {
            top: 4783,
            height: 1559,
            color: '#ffffff',
        },
        {
            top: 2423,
            height: 2360,
            color: '#ffffff',
        },
        {
            top: 1984,
            height: 440,
            color: '#ff5c8a',
        },
        {
            top: 1128,
            height: 856,
            color: '#fff4f7',
        },
        {
            top: 810,
            height: 318,
            color: '#ff5c8a',
        },
        {
            top: 0,
            height: 810,
            file: 'backdrop-125.png',
        },
    ],
    artworks: [
        {
            top: 0,
            left: 0,
            width: 1260,
            height: 810,
            file: 'section-0.webp',
            alt: '영어 학습 어린이와 윙크 학습기',
        },
        {
            top: 1128,
            left: 0,
            width: 1260,
            height: 858,
            file: 'section-1.webp',
            alt: '영어와 파닉스 학습 영역 안내',
            clipBottom: 2,
        },
        {
            top: 1984,
            left: 0,
            width: 1260,
            height: 440,
            file: 'section-2.webp',
            alt: '영어 학습 4단계 흐름',
        },
        {
            top: 2423,
            left: 0,
            width: 1260,
            height: 2360,
            file: 'section-3.webp',
            alt: '영어 학습 콘텐츠 예시',
        },
        {
            top: 4782.5,
            left: 0,
            width: 1260,
            height: 1559,
            file: 'section-4.webp',
            alt: '영어 학습 효과 안내',
        },
        {
            top: 6342,
            left: -649,
            width: 2560,
            height: 440,
            file: 'section-5.webp',
            alt: '영어 단계별 커리큘럼',
        },
        {
            top: 6782,
            left: 0,
            width: 1260,
            height: 2410,
            file: 'section-6.webp',
            alt: '헬로잉글리시부터 영어 첫걸음 학습 예시',
        },
        {
            top: 9192,
            left: 0,
            width: 1260,
            height: 1567,
            file: 'section-7.webp',
            alt: '영어 1~2단계 학습 예시',
        },
        {
            top: 10759,
            left: 0,
            width: 1260,
            height: 1225,
            file: 'section-8.webp',
            alt: '영어 3단계 학습 예시',
        },
    ],
    sections: [
        {
            key: 'contents_0(메인)',
            top: 0,
            height: 810,
        },
        {
            key: 'contents_1',
            top: 810,
            height: 1174,
        },
        {
            key: 'contents_2',
            top: 1984,
            height: 440,
            groups: [
                {
                    kind: 'list',
                    label: '스토리 영어 학습 4단계',
                    items: [['2019:1924'], ['2019:1925'], ['2019:1926'], ['2019:1927']],
                },
            ],
        },
        {
            key: 'contents_3',
            top: 2423,
            height: 2360,
        },
        {
            key: 'contents_4',
            top: 4783,
            height: 1559,
        },
        {
            key: 'contents_5',
            top: 6342,
            height: 440,
            groups: [
                {
                    kind: 'list',
                    label: '스토리 영어 수준별 5개 과정',
                    items: [
                        ['2019:1861', '2019:1862'],
                        ['2019:1864', '2019:1863'],
                        ['2019:1866', '2019:1865'],
                        ['2019:1868', '2019:1867'],
                        ['2019:1870', '2019:1869'],
                    ],
                },
            ],
        },
        {
            key: 'contents_6',
            top: 6782,
            height: 2410,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:1855',
                    keys: ['2019:1855', '2019:1856', '2019:1851', '2019:1852', '2019:1853'],
                },
                {
                    kind: 'course',
                    heading: '2019:1848',
                    keys: ['2019:1848', '2019:1849', '2019:1846', '2019:1843', '2019:1844', '2019:1845'],
                },
                {
                    kind: 'course',
                    heading: '2019:1840',
                    keys: ['2019:1840', '2019:1841', '2019:1838', '2019:1835', '2019:1836', '2019:1837'],
                },
            ],
        },
        {
            key: 'contents_7',
            top: 9192,
            height: 1567,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:1828',
                    keys: ['2019:1828', '2019:1829', '2019:1826', '2019:1822', '2019:1823', '2019:1824', '2019:1825'],
                },
                {
                    kind: 'course',
                    heading: '2019:1819',
                    keys: ['2019:1819', '2019:1820', '2019:1817', '2019:1814', '2019:1815', '2019:1816'],
                },
            ],
        },
        {
            key: 'contents_8',
            top: 10759,
            height: 1225,
            groups: [
                {
                    kind: 'course',
                    heading: '2019:1804',
                    keys: [
                        '2019:1804',
                        '2019:1805',
                        '2019:1801',
                        '2019:1802',
                        '2019:1790',
                        '2019:1797',
                        '2019:1792',
                        '2019:1798',
                        '2019:1794',
                        '2019:1799',
                        '2019:1796',
                        '2019:1800',
                    ],
                },
            ],
        },
    ],
    texts: [
        {
            key: '2019:1960',
            tag: 'p',
            left: 81.5,
            top: 271,
            width: 35,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '영어',
                    left: 0.215,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:1962',
            tag: 'h1',
            left: 47,
            top: 320.5,
            width: 502,
            height: 225,
            lineHeight: 75,
            runs: [
                {
                    text: '우리말을 익히듯',
                    left: 0,
                    top: 0,
                },
                {
                    text: '자연스럽게, 영어가',
                    left: 0,
                    top: 75,
                },
                {
                    text: '아이의 일상이 됩니다',
                    left: 0,
                    top: 150,
                },
            ],
            font: 'Paperlogy',
            size: 60,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1953',
            tag: 'p',
            left: 375,
            top: 875,
            width: 511,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '영어가 일상이 되려면 방식부터 달라야겠죠?',
                    left: 0.13,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 600,
            color: 'white',
        },
        {
            key: '2019:1954',
            tag: 'h2',
            left: 190,
            top: 932.9999,
            width: 880,
            height: 130,
            lineHeight: 65,
            runs: [
                {
                    text: '흥미로운 수준별 스토리와 체계적인 학습으로',
                    left: 0.083,
                    top: 0,
                },
                {
                    text: '영어가 일상이 되는 ',
                    left: 154.062,
                    top: 65,
                },
                {
                    text: '윙크 영어',
                    color: '#FFF345',
                    left: 538.97,
                    top: 65,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1943',
            tag: 'h2',
            left: 251,
            top: 1191,
            width: 745,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 스토리 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '영어&파닉스',
                    color: '#FF5C8A',
                    left: 384.91,
                    top: 0,
                },
                {
                    text: ' 구성',
                    left: 645.31,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1947',
            tag: 'p',
            left: 340.5,
            top: 1370,
            width: 81,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '정규 수업',
                    left: 0.077,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 900,
            color: 'white',
        },
        {
            key: '2019:1949',
            tag: 'p',
            left: 783.5,
            top: 1370,
            width: 191,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '자동 복습 및 흘려 듣기',
                    left: 0.36,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 900,
            color: 'white',
        },
        {
            key: '2019:1940',
            tag: 'p',
            left: 929,
            top: 1528.8906,
            width: 138,
            height: 58,
            lineHeight: 29,
            runs: [
                {
                    text: '영어 애니.DVD',
                    left: 0.17,
                    top: 0,
                },
                {
                    text: '인기 영어 동요',
                    left: 5.8,
                    top: 29,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1934',
            tag: 'p',
            left: 211,
            top: 1544,
            width: 103,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '스토리 영어',
                    left: 0.462,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1936',
            tag: 'p',
            left: 434,
            top: 1544,
            width: 132,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '파닉스+영단어',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1938',
            tag: 'p',
            left: 696,
            top: 1544,
            width: 129,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '영어 동화.노래',
                    left: 0.36,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1935',
            tag: 'p',
            left: 198,
            top: 1585.2148,
            width: 129,
            height: 42,
            lineHeight: 21,
            runs: [
                {
                    text: 'Hello English ',
                    left: 15.859,
                    top: 0,
                },
                {
                    text: '+ 첫걸음 + 1~3단계',
                    left: 0.305,
                    top: 21,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1937',
            tag: 'p',
            left: 472,
            top: 1594.582,
            width: 56,
            height: 21,
            lineHeight: 21,
            runs: [
                {
                    text: '1~4단계',
                    left: 0.43,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1939',
            tag: 'p',
            left: 676,
            top: 1599,
            width: 168,
            height: 63,
            lineHeight: 21,
            runs: [
                {
                    text: '맞춤 스케줄링에 의한 ',
                    left: 15.91,
                    top: 0,
                },
                {
                    text: '정규수업 스토리, 노래 반복',
                    left: 0.03,
                    top: 21,
                },
                {
                    text: '장기 기억화',
                    left: 47.48,
                    top: 42,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1941',
            tag: 'p',
            left: 918,
            top: 1599,
            width: 160,
            height: 63,
            lineHeight: 21,
            runs: [
                {
                    text: '아이의 생활 패턴에 맞춘',
                    left: 5,
                    top: 0,
                },
                {
                    text: '자동 설정으로 자연스러운',
                    left: 0.04,
                    top: 21,
                },
                {
                    text: '영어 흘려듣기 가능',
                    left: 20.78,
                    top: 42,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1944',
            tag: 'p',
            left: 136,
            top: 1733,
            width: 939,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '연령별, 주제별로 다양하고 체계적인 커리큘럼이 제공되어 아이 혼자 힘으로 쉽고 재미있게 영어를 매일 접하게 됩니다.',
                    left: 30,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1945',
            tag: 'p',
            left: 136,
            top: 1797,
            width: 973,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '입학 전, 초등 준비 학습 프로그램을 통해 학교 진도와 동일한 교과학습을 미리 공부할 수 있어 입학 후, 학교 학습에 쉽게',
                    left: 30,
                    top: 0,
                },
                {
                    text: '적응할 수 있습니다.',
                    left: 30,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1928',
            tag: 'h2',
            left: 289.9994,
            top: 2054,
            width: 671,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 스토리 영어 학습 흐름',
                    left: 0.0756,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1924',
            tag: 'p',
            left: 95.0254,
            top: 2212.8691,
            width: 196,
            height: 78,
            lineHeight: 39,
            runs: [
                {
                    text: '흥미유발, 호기심',
                    left: 0.0736,
                    top: 0,
                },
                {
                    text: '자극 과정',
                    left: 42.7876,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1927',
            tag: 'p',
            left: 960.8807,
            top: 2213.2617,
            width: 195,
            height: 78,
            lineHeight: 39,
            runs: [
                {
                    text: '영어 환경 ',
                    left: 38.9293,
                    top: 0,
                },
                {
                    text: '상시 노출 시스템',
                    left: 0.0393,
                    top: 39,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1925',
            tag: 'p',
            left: 426.3104,
            top: 2232.8691,
            width: 111,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '인지 과정',
                    left: 0.2796,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1926',
            tag: 'p',
            left: 716.5957,
            top: 2232.8691,
            width: 111,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '발화 과정',
                    left: 0.2843,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1894',
            tag: 'h2',
            left: 361,
            top: 2581,
            width: 539,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '흥미유발, 호기심 ',
                    left: 56.92,
                    top: 0,
                },
                {
                    text: '자극 과정',
                    color: '#1D1D1D',
                    left: 332.51,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#F44B7B',
        },
        {
            key: '2019:1895',
            tag: 'p',
            left: 361,
            top: 2635,
            width: 539,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '실물 스토리북과 연계된 학습기 콘텐츠를 통해 영어에 대한',
                    left: 0.09,
                    top: 0,
                },
                {
                    text: '흥미를 키우고 다양한 표현을 접해요',
                    left: 102.21,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1888',
            tag: 'h3',
            left: 347,
            top: 3005,
            width: 138,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Story Pop',
                    left: 13.84,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1891',
            tag: 'h3',
            left: 693,
            top: 3005,
            width: 291,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Story Time',
                    left: 83.86,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1889',
            tag: 'p',
            left: 347,
            top: 3042,
            width: 138,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '책에 대한 흥미 유발',
                    left: 0.182,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1892',
            tag: 'p',
            left: 693,
            top: 3042,
            width: 291,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '부모님이 읽어 주는 듯한 한영 스토리 노출',
                    left: 0.08,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1903',
            tag: 'h2',
            left: 347,
            top: 3220,
            width: 566,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '인지 ',
                    left: 208.21,
                    top: 0,
                },
                {
                    text: '과정',
                    color: '#1D1D1D',
                    left: 287.39,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#F44B7B',
        },
        {
            key: '2019:1904',
            tag: 'p',
            left: 347,
            top: 3274,
            width: 566,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '배운 표현을 영어로만 반복해 들으며 어떤 의미인지 인지하고 ',
                    left: 0.285,
                    top: 0,
                },
                {
                    text: '반복 노출을 통해 배운 표현과 어휘를 오래 기억하게 되어요.',
                    left: 7.49,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1897',
            tag: 'h3',
            left: 257,
            top: 3644,
            width: 318,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Ani Fun Fun',
                    left: 93.23,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1900',
            tag: 'h3',
            left: 713,
            top: 3644,
            width: 251,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Story Song',
                    left: 62.98,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1898',
            tag: 'p',
            left: 257,
            top: 3681,
            width: 318,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '영어로만 들으며 스토리에 대한 되새김질 노출',
                    left: 0.226,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1901',
            tag: 'p',
            left: 713,
            top: 3681,
            width: 251,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '주요 표현과 낱말을 노래로 반복노출',
                    left: 0.04,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1918',
            tag: 'h2',
            left: 350,
            top: 3859,
            width: 560,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '발화 ',
                    left: 205.21,
                    top: 0,
                },
                {
                    text: '과정',
                    color: '#1D1D1D',
                    left: 284.39,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#F44B7B',
        },
        {
            key: '2019:1919',
            tag: 'p',
            left: 350,
            top: 3913,
            width: 560,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '다양한 놀이 콘텐츠로 배운 표현과 어휘를 따라하고 발화하며',
                    left: 0.21,
                    top: 0,
                },
                {
                    text: '자연스럽게 영어로 표현할 수 있게 되어요.',
                    left: 85.88,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1906',
            tag: 'h3',
            left: 276,
            top: 4283,
            width: 280,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Let’s Sing / Let’s Read',
                    left: 17,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1909',
            tag: 'h3',
            left: 649,
            top: 4283,
            width: 378,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Play',
                    left: 165.23,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1907',
            tag: 'p',
            left: 276,
            top: 4320,
            width: 280,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '노출받은 문장, 낱말 표현 발화 유도 학습',
                    left: 0.052,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1910',
            tag: 'p',
            left: 649,
            top: 4320,
            width: 378,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '다양한 놀이 학습을 통해 주요 표현과 낱말을 반복 노출',
                    left: 0.3,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1912',
            tag: 'h3',
            left: 267,
            top: 4624,
            width: 298,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Talk & Play',
                    left: 88.6,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1915',
            tag: 'h3',
            left: 667,
            top: 4624,
            width: 342,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: 'Quiz Time',
                    left: 114.13,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1913',
            tag: 'p',
            left: 267,
            top: 4661,
            width: 298,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '생활 속에서 자연스럽고 재미있게 발화하고',
                    left: 0.201,
                    top: 0,
                },
                {
                    text: '쓰임을 익히는 표현 학습',
                    left: 64.625,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1916',
            tag: 'p',
            left: 667,
            top: 4661,
            width: 342,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '듣고, 익히고, 연습한 내용 정리/ 성취감 확인 학습',
                    left: 0.1,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1880',
            tag: 'h2',
            left: 419,
            top: 4873,
            width: 423,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '상시 영어 환경 ',
                    left: 0.7,
                    top: 0,
                },
                {
                    text: '노출 시스템',
                    color: '#1D1D1D',
                    left: 238.23,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#F44B7B',
        },
        {
            key: '2019:1881',
            tag: 'p',
            left: 334,
            top: 4927,
            width: 593,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '학습 후에도 수시로 영어 흘려듣기를 하며 노출 시간을 확보하고 ',
                    left: 0.484,
                    top: 0,
                },
                {
                    text: '영어 도서관의 다양한 읽기 콘텐츠를 통해 리딩 실력을 강화해요.',
                    left: 0.25,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1878',
            tag: 'p',
            left: 570.5,
            top: 5075,
            width: 119,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '영어 흘려듣기',
                    left: 0.06,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 900,
            color: 'white',
        },
        {
            key: '2019:1879',
            tag: 'p',
            left: 333,
            top: 5133,
            width: 608,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '아이의 생활 패턴에 맞춰 시간을 설정하면, 그 시간에 영어 애니메이션과 동화가',
                    left: 0.455,
                    top: 0,
                },
                {
                    text: '자동 재생되어 집에서 자연스럽게 영어를 접할 수 있는 환경이 조성됩니다.',
                    left: 20.11,
                    top: 28,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1876',
            tag: 'p',
            left: 580,
            top: 5521,
            width: 100,
            height: 29,
            lineHeight: 29,
            runs: [
                {
                    text: '영어 도서관',
                    left: 0.07,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 22,
            weight: 900,
            color: 'white',
        },
        {
            key: '2019:1882',
            tag: 'p',
            left: 371,
            top: 5579,
            width: 533,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '미국 초등학교에서도 활용되는 11개 레벨, 1,000여 권의 도서를 제공!',
                    left: 0.27,
                    top: 0,
                },
                {
                    text: '단순 E-BOOK이 아닌 6단계 학습 프로세스로',
                    left: 89.62,
                    top: 28,
                },
                {
                    text: '자녀의 리딩 레벨을 효과적으로 향상시킬 수 있습니다.',
                    left: 59.08,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1860',
            tag: 'h2',
            left: 298.4999,
            top: 6407,
            width: 660,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '윙크 수준별 스토리 영어 커리큘럼',
                    left: 0.0681,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:1861',
            tag: 'p',
            left: 19,
            top: 6565.8711,
            width: 131,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '재미있는 놀이 및',
                    left: 0.393,
                    top: 0,
                },
                {
                    text: '챈트로 영어를',
                    left: 11.34,
                    top: 28,
                },
                {
                    text: '시작하는 코스',
                    left: 11.34,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1868',
            tag: 'p',
            left: 807,
            top: 6566,
            width: 178,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '서사구조를 갖춘',
                    left: 26.2,
                    top: 0,
                },
                {
                    text: '스토리로 3인칭 구조와',
                    left: 0.22,
                    top: 28,
                },
                {
                    text: '긴 문장 학습',
                    left: 41.18,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1870',
            tag: 'p',
            left: 1083,
            top: 6566,
            width: 165,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '논픽션 주제의 ',
                    left: 26.04,
                    top: 0,
                },
                {
                    text: '이야기를 통해 복잡한',
                    left: 0.11,
                    top: 28,
                },
                {
                    text: '표현, 문장 학습',
                    left: 23.48,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1864',
            tag: 'p',
            left: 278.9998,
            top: 6566.002,
            width: 153,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '기초 어휘로 구성된 ',
                    left: 0.4452,
                    top: 0,
                },
                {
                    text: '스토리북을 통해',
                    left: 13.6972,
                    top: 28,
                },
                {
                    text: '생활표현 학습',
                    left: 22.3402,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1866',
            tag: 'p',
            left: 535.0004,
            top: 6566.002,
            width: 183,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '재미있는 이야기를 통해',
                    left: 0.4596,
                    top: 0,
                },
                {
                    text: '1,2인칭 구조 및',
                    left: 30.3896,
                    top: 28,
                },
                {
                    text: '표현, 단어 학습',
                    left: 32.4796,
                    top: 56,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:1862',
            tag: 'p',
            left: 12,
            top: 6661,
            width: 145,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 30~38개월',
                    left: 0.117,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1863',
            tag: 'p',
            left: 299.9998,
            top: 6661,
            width: 111,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 4~7세',
                    left: 0.4692,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1865',
            tag: 'p',
            left: 570.9999,
            top: 6661,
            width: 111,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 7~8세',
                    left: 0.4101,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1869',
            tag: 'p',
            left: 1104,
            top: 6661,
            width: 123,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 9세 이상',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1867',
            tag: 'p',
            left: 840,
            top: 6661.3906,
            width: 112,
            height: 22,
            lineHeight: 22,
            runs: [
                {
                    text: '권장 연령: 8~9세',
                    left: 0.4,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 16,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1855',
            tag: 'h3',
            left: 566,
            top: 6919,
            width: 144,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '헬로잉글리시 단계',
                    left: 0.42,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1856',
            tag: 'p',
            left: 389,
            top: 6952,
            width: 498,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '재미있는 놀이 및 챈트로 영어를 시작하는 코스',
                    left: 0.32,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1851',
            tag: 'p',
            left: 184,
            top: 7324,
            width: 871,
            height: 84,
            lineHeight: 28,
            runs: [
                {
                    text: '헬로잉글리시는 일상에서 주로 사용하는 어휘들이 영어로 어떻게 표현되는지 알아보며 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '영어에 대한 ‘호기심\'과',
                    color: '#F14676',
                    left: 696.21,
                    top: 0,
                },
                {
                    text: '      ‘친밀감\'',
                    color: '#F14676',
                    left: 0,
                    top: 28,
                },
                {
                    text: '을 갖게 합니다. 처음 영어를 접하는 아이에게 새로운 언어에 대한 두려움이나 거부감을 주지 않도록',
                    left: 89.863,
                    top: 28,
                },
                {
                    text: '      재미있는 놀이 활동으로 구성되어 있습니다.',
                    left: 0,
                    top: 56,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1852',
            tag: 'p',
            left: 184,
            top: 7433,
            width: 899,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '단순한 가사의 쉽고 재미있는 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '챈트 음원을 통해 주요 어휘들을 노출',
                    color: '#F14676',
                    left: 256.95,
                    top: 0,
                },
                {
                    text: '시키고 이후 놀이 인터랙션에서도 챈트 음악을',
                    left: 540.64,
                    top: 0,
                },
                {
                    text: '      배경 음악으로 활용하여 ',
                    left: 0,
                    top: 28,
                },
                {
                    text: '자연스럽게 새로운 어휘에 익숙',
                    color: '#F14676',
                    left: 216.8,
                    top: 28,
                },
                {
                    text: '해지게 됩니다.',
                    left: 456.15,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1853',
            tag: 'p',
            left: 184,
            top: 7514,
            width: 877,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '다양한 놀이 인터랙션을 진행하는 동안 학습자는 기초 어휘 외에도 감각이나 감정을 나타내는 일상적인 표현 등',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      풍부한 Sight words를 함께 습득할 수 있습니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1848',
            tag: 'h3',
            left: 572.5,
            top: 7705,
            width: 131,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '영어 첫걸음 단계',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1849',
            tag: 'p',
            left: 365,
            top: 7738,
            width: 546,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '기초 어휘로 구성된 스토리북을 통해 생활표현 학습',
                    left: 0.12,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1846',
            tag: 'h3',
            left: 488,
            top: 7804,
            width: 300,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 1학년 1학기 교과 수준 포함',
                    left: 0.47,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1843',
            tag: 'p',
            left: 184,
            top: 8147,
            width: 882,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '다채로운 그림을 기반으로 진행되는 이야기 속에서 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '일상 생활에 꼭 필요한 기초 표현과 낱말이 반복',
                    color: '#F14676',
                    left: 422.29,
                    top: 0,
                },
                {
                    text: ' 노출됩니다.',
                    left: 784.88,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1844',
            tag: 'p',
            left: 184,
            top: 8200,
            width: 884,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '한 달에 3권의 이야기 책(일주일에 1권씩)과 1권의 워크북',
                    left: 30,
                    top: 0,
                },
                {
                    text: '으로 학습하며, 마지막 주에는 읽은 책들을 다시 한 번 ',
                    color: '#1D1D1D',
                    left: 471.88,
                    top: 0,
                },
                {
                    text: '      상기할 수 있는 ',
                    color: '#1D1D1D',
                    left: 0,
                    top: 28,
                },
                {
                    text: '복습이 진행',
                    left: 147.656,
                    top: 28,
                },
                {
                    text: '됩니다.',
                    color: '#1D1D1D',
                    left: 238.96,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1845',
            tag: 'p',
            left: 184,
            top: 8281,
            width: 900,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '52주 동안 39편의 이야기와 13권의 워크북',
                    left: 30,
                    top: 0,
                },
                {
                    text: '을 통해 기초적인 ',
                    color: '#1D1D1D',
                    left: 366.82,
                    top: 0,
                },
                {
                    text: '생활 표현 약 80개',
                    left: 502.46,
                    top: 0,
                },
                {
                    text: '와 그 표현과 함께 사용할 수 있는',
                    color: '#1D1D1D',
                    left: 645.53,
                    top: 0,
                },
                {
                    text: '      200개 이상의 낱말을 학습',
                    left: 0,
                    top: 28,
                },
                {
                    text: '하게 됩니다.',
                    color: '#1D1D1D',
                    left: 236.09,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1840',
            tag: 'h3',
            left: 596.5,
            top: 8472,
            width: 83,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '영어 1단계',
                    left: 0.01,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1841',
            tag: 'p',
            left: 336,
            top: 8505,
            width: 604,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '재미있는 이야기를 통해 1,2인칭 구조 및 표현, 단어 학습',
                    left: 0.289,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1838',
            tag: 'h3',
            left: 500,
            top: 8571,
            width: 277,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 3~4학년 교과 수준 포함',
                    left: 0.34,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1835',
            tag: 'p',
            left: 184,
            top: 8914,
            width: 865,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '단순한 서사 구조와 재미있는 장면들을 통해, ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '생활 속에서 많이 쓰이는 기초 표현들을 자연스럽게 습득',
                    color: '#F14676',
                    left: 375.57,
                    top: 0,
                },
                {
                    text: '합니다.',
                    left: 807.3,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1836',
            tag: 'p',
            left: 184,
            top: 8967,
            width: 884,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '한 달에 3권의 이야기 책(일주일에 1권씩)과 1권의 워크북',
                    left: 30,
                    top: 0,
                },
                {
                    text: '으로 학습하며, 마지막 주에는 읽은 책들을 다시 한 번 ',
                    color: '#1D1D1D',
                    left: 471.88,
                    top: 0,
                },
                {
                    text: '      상기할 수 있는 ',
                    color: '#1D1D1D',
                    left: 0,
                    top: 28,
                },
                {
                    text: '복습이 진행',
                    left: 147.656,
                    top: 28,
                },
                {
                    text: '됩니다.',
                    color: '#1D1D1D',
                    left: 238.96,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1837',
            tag: 'p',
            left: 184,
            top: 9048,
            width: 900,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '52주 동안 39편의 이야기와 13권의 워크북',
                    left: 30,
                    top: 0,
                },
                {
                    text: '을 통해 기초적인 ',
                    color: '#1D1D1D',
                    left: 366.82,
                    top: 0,
                },
                {
                    text: '생활 표현 약 80개',
                    left: 502.46,
                    top: 0,
                },
                {
                    text: '와 그 표현과 함께 사용할 수 있는',
                    color: '#1D1D1D',
                    left: 645.53,
                    top: 0,
                },
                {
                    text: '      200개 이상의 낱말을 학습',
                    left: 0,
                    top: 28,
                },
                {
                    text: '하게 됩니다.',
                    color: '#1D1D1D',
                    left: 236.09,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1828',
            tag: 'h3',
            left: 595,
            top: 9238,
            width: 86,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '영어 2단계',
                    left: 0.04,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1829',
            tag: 'p',
            left: 352.5,
            top: 9271,
            width: 571,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '서사구조를 갖춘 스토리로 3인칭 구조와 긴 문장 학습',
                    left: 0.44,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1826',
            tag: 'h3',
            left: 500,
            top: 9337,
            width: 276,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 3~5학년 교과 수준 포함',
                    left: 0.2,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1822',
            tag: 'p',
            left: 184,
            top: 9680,
            width: 931,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '1단계보다 좀 더 서사적인 구조, 기승전결의 구성이 확실하고 갈등 구조가 명확히 보이는 이야기로 구성되어 있습니다.',
                    left: 30,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1823',
            tag: 'p',
            left: 184,
            top: 9733,
            width: 862,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '이웃, 사회 등 좀 더',
                    left: 30,
                    top: 0,
                },
                {
                    text: ' 확장된 생활 범위 속에서 유용하게 쓰이는 표현',
                    color: '#F14676',
                    left: 175.66,
                    top: 0,
                },
                {
                    text: '들이 재미있는 이야기 속에 녹아 있습니다.',
                    left: 538.26,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1824',
            tag: 'p',
            left: 184,
            top: 9786,
            width: 881,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '3인칭 문장의 비중이 높아지며, 2단계 학습하는 동안',
                    left: 30,
                    top: 0,
                },
                {
                    text: ' 270여 개의 주요 낱말과 100여개의 생활 표현',
                    color: '#F14676',
                    left: 434.51,
                    top: 0,
                },
                {
                    text: '을 익힐 수 ',
                    left: 796.76,
                    top: 0,
                },
                {
                    text: '      있습니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1825',
            tag: 'p',
            left: 184,
            top: 9867,
            width: 709,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '50주 동안 25편의 이야기',
                    left: 30,
                    top: 0,
                },
                {
                    text: '로 학습이 진행되며, ',
                    color: '#1D1D1D',
                    left: 231.39,
                    top: 0,
                },
                {
                    text: '각 스토리에는 워크북이 함께 제공됩니다.',
                    left: 389.45,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1819',
            tag: 'h3',
            left: 594.5,
            top: 10030,
            width: 87,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '영어 3단계',
                    left: 0.25,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1820',
            tag: 'p',
            left: 358,
            top: 10063,
            width: 560,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '논픽션 주제의 이야기를 통해 복잡한 표현, 문장 학습',
                    left: 0.42,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1817',
            tag: 'h3',
            left: 500,
            top: 10129,
            width: 276,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 5~6학년 교과 수준 포함',
                    left: 0.15,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#4A4A4A',
        },
        {
            key: '2019:1814',
            tag: 'p',
            left: 181,
            top: 10472,
            width: 894,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '3단계에서는 ',
                    left: 30,
                    top: 0,
                },
                {
                    text: '자연탐구 지식이나 좀 더 일반적인 주제',
                    color: '#F14676',
                    left: 133.789,
                    top: 0,
                },
                {
                    text: ' 등 2단계에 비해 좀 더 ',
                    left: 434.77,
                    top: 0,
                },
                {
                    text: '폭넓은 영여과 주제를 다룬 이야기',
                    color: '#F14676',
                    left: 614.24,
                    top: 0,
                },
                {
                    text: '를',
                    left: 875.76,
                    top: 0,
                },
                {
                    text: '      접할 수 있습니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1815',
            tag: 'p',
            left: 181,
            top: 10553,
            width: 821,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '복합적인 구조와 길이가 더 긴 문장',
                    left: 30,
                    top: 0,
                },
                {
                    text: '의 비중이 높아지며, 문장의 형식 또한 좀 더 다양해 집니다. ',
                    color: '#1D1D1D',
                    left: 296.41,
                    top: 0,
                },
                {
                    text: '      3단계의 재미있는 이야기 속에는 ',
                    color: '#1D1D1D',
                    left: 0,
                    top: 28,
                },
                {
                    text: '약 250개의 주요 낱말과 100개 이상의 주요 표현',
                    left: 286.02,
                    top: 28,
                },
                {
                    text: '들이 녹아 있습니다.',
                    color: '#1D1D1D',
                    left: 666.78,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1816',
            tag: 'p',
            left: 181,
            top: 10634,
            width: 709,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '50주 동안 25편의 이야기',
                    left: 30,
                    top: 0,
                },
                {
                    text: '로 학습이 진행되며, ',
                    color: '#1D1D1D',
                    left: 231.43,
                    top: 0,
                },
                {
                    text: '각 스토리에는 워크북이 함께 제공됩니다.',
                    left: 389.49,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#F14676',
        },
        {
            key: '2019:1804',
            tag: 'h3',
            left: 575,
            top: 10924,
            width: 126,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '파닉스 1~4단계',
                    left: 0.16,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: 'white',
        },
        {
            key: '2019:1805',
            tag: 'p',
            left: 443.5,
            top: 10957,
            width: 389,
            height: 36,
            lineHeight: 36,
            runs: [
                {
                    text: '알파벳부터 단계별 파닉스 규칙 학습',
                    left: 0.48,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 28,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:1801',
            tag: 'p',
            left: 190,
            top: 11328,
            width: 901,
            height: 56,
            lineHeight: 28,
            runs: [
                {
                    text: '스토리 영어와 함께 매주 1회는 파닉스 학습이 고정적으로 진행되며 기본 알파벳과 음가뿐 아니라, 단모음, 장모음,',
                    left: 30,
                    top: 0,
                },
                {
                    text: '      복합자음 등 2음가 이상의 예외적 음가 학습까지 진행됩니다.',
                    left: 0,
                    top: 28,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1802',
            tag: 'p',
            left: 190,
            top: 11403,
            width: 327,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '윙크 파닉스는 총 4단계로 구성됩니다.',
                    left: 30,
                    top: 0,
                },
            ],
            bullet: true,
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#6C47F4',
        },
        {
            key: '2019:1790',
            tag: 'p',
            left: 225,
            top: 11448,
            width: 44,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '1단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#6C47F4',
        },
        {
            key: '2019:1797',
            tag: 'p',
            left: 285,
            top: 11448,
            width: 288,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '알파벳 A~Z을 연계 단어와 함께 학습',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1792',
            tag: 'p',
            left: 223,
            top: 11492,
            width: 47,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '2단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#6C47F4',
        },
        {
            key: '2019:1798',
            tag: 'p',
            left: 285,
            top: 11492,
            width: 212,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '단모음/ 장모음 파닉스 학습',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1794',
            tag: 'p',
            left: 223,
            top: 11536,
            width: 48,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '3단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#6C47F4',
        },
        {
            key: '2019:1799',
            tag: 'p',
            left: 285,
            top: 11536,
            width: 206,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '복합자음, 이중자모음 학습',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1796',
            tag: 'p',
            left: 223,
            top: 11580,
            width: 48,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '4단계',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#6C47F4',
        },
        {
            key: '2019:1800',
            tag: 'p',
            left: 285,
            top: 11580,
            width: 223,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '묵음과 이중자모음 심화 학습',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:1807',
            tag: 'p',
            left: 447,
            top: 11771,
            width: 339,
            height: 45,
            lineHeight: 45,
            runs: [
                {
                    text: '초등 입학 대비 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '보러 가기',
                    color: '#65D994',
                    left: 207.85,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 35,
            weight: 800,
            color: 'white',
        },
    ],
    label: '영어·파닉스',
    frame: '2019:1782',
    heading: '2019:1962',
    link: {
        key: '2019:1807',
        left: 385,
        top: 11746,
        width: 491,
        height: 95,
        href: '/subject/prepare',
        id: 'subject-en-next-button',
    },
    animations: [],
    decorationShift: {
        top: 2426,
        by: -3,
    },
};
